import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const res = await http.get("/auth/me");
            setUser(res.data);
            return res.data;
        } catch {
            setUser(null);
            return null;
        }
    }, []);

    useEffect(() => {
        // Skip /me check while AuthCallback exchanges session_id
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh().finally(() => setLoading(false));
    }, [refresh]);

    const logout = async () => {
        try {
            await http.post("/auth/logout");
        } catch {
            // no-op
        }
        setUser(null);
        window.location.href = "/login";
    };

    return (
        <AuthCtx.Provider value={{ user, setUser, loading, refresh, logout }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
